// blog33.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg";
import detailImg from "../Asets/blog3737.png";
import Header from "../components/header";
import Footer from "../components/footer";

const Blog33 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span>
                {" "}
                / Our Blog / The Importance of Hygiene Habits for Preschool
                Children
              </span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            The Importance of Hygiene Habits for Preschool Children
          </h2>

          <br />
          <div className="published-badge">
            Published on: 13 December 2025
          </div>
          <br />

          <img
            src={detailImg}
            alt="The Importance of Hygiene Habits for Preschool Children"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Hygiene plays a crucial role in the healthy growth and development
              of preschool children. At <strong>Red House School</strong>, the
              best play school in Harni, Vadodara, we strongly believe that
              teaching good hygiene habits from an early age helps children stay
              healthy, confident, and ready to learn.
            </p>
            <p>
              Preschool years are the perfect time to introduce simple hygiene
              routines that shape a child’s lifelong habits.
            </p>

            <hr />

            <h3>🧼 Why Hygiene Is Important in Early Childhood</h3>
            <p>
              Young children are more exposed to germs due to frequent play,
              interaction, and exploration. Proper hygiene helps:
            </p>
            <ul>
              <li>Prevent common illnesses and infections</li>
              <li>Build strong immunity</li>
              <li>Improve overall physical health</li>
              <li>Develop self-care and independence</li>
              <li>Create a safe and clean learning environment</li>
            </ul>
            <p>
              A trusted play school in Harni Vadodara focuses not only on
              education but also on children’s well-being.
            </p>

            <hr />

            <h3>👶 Key Hygiene Habits Every Preschool Child Should Learn</h3>
            <p>
              At <strong>Red House School Vadodara</strong>, children are gently
              guided to practice essential hygiene habits such as:
            </p>

            <p><strong>🧼 Handwashing</strong></p>
            <p>
              Teaching children to wash their hands before meals, after
              playtime, and after using the washroom helps reduce the spread of
              germs.
            </p>

            <p><strong>🪥 Oral Hygiene</strong></p>
            <p>
              Simple habits like brushing teeth daily help prevent cavities and
              promote healthy smiles.
            </p>

            <p><strong>👕 Personal Cleanliness</strong></p>
            <p>
              Wearing clean clothes, using handkerchiefs, and maintaining
              personal neatness boost confidence and discipline.
            </p>

            <p><strong>🍽️ Food Hygiene</strong></p>
            <p>
              Children are encouraged to eat clean, wash hands before meals, and
              understand the importance of healthy eating habits.
            </p>

            <hr />

            <h3>📚 How Hygiene Supports Learning at Play School</h3>
            <p>
              Good hygiene directly impacts a child’s ability to learn and
              participate. Clean and healthy children:
            </p>
            <ul>
              <li>Miss fewer school days due to illness</li>
              <li>Are more active and attentive in class</li>
              <li>Feel confident during group activities</li>
              <li>Learn better social and life skills</li>
            </ul>
            <p>
              At a quality play school in Harni, hygiene is part of everyday
              learning — not just a rule, but a habit.
            </p>

            <hr />

            <h3>🏫 Hygiene Education at Red House School</h3>
            <p>
              As a leading play school in Harni Vadodara, Red House School
              maintains:
            </p>
            <ul>
              <li>Clean and child-safe classrooms</li>
              <li>Regular sanitation routines</li>
              <li>Hygiene awareness through fun activities</li>
              <li>A nurturing environment that promotes healthy habits</li>
            </ul>
            <p>
              Our teachers guide children with care, patience, and positive
              reinforcement so hygiene becomes a natural part of daily life.
            </p>

            <hr />

            <h3>❤️ Why Parents Trust Red House School, Harni Vadodara</h3>
            <ul>
              <li>Safe and hygienic learning environment</li>
              <li>Focus on holistic child development</li>
              <li>Caring and experienced educators</li>
              <li>Strong emphasis on health, hygiene, and early learning</li>
              <li>Convenient location in Harni</li>
            </ul>

            <hr />

            <h3>📞 Contact &amp; Location Details</h3>
            <p>
              <strong>Address:</strong> A-25, Castle White, Opposite Main Harni
              Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong>{" "}
              <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>
              <br />
              <strong>Website:</strong>{" "}
              <a
                href="https://www.redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.redhouseschoolvadodara.in/
              </a>
              <br />
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.instagram.com/redschoolhousebaroda/
              </a>
            </p>

            <p className="blog-tags">
              #HygieneHabits &nbsp;
              #PlaySchoolInHarni &nbsp;
              #RedHouseSchoolVadodara &nbsp;
              #PreschoolCare &nbsp;
              #HealthyKids &nbsp;
              #EarlyLearning
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog33;
